import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BaseConhecimentoRoutingModule } from './base-conhecimento-routing.module';
import { BaseConhecimentoListarComponent } from './base-conhecimento-listar/base-conhecimento-listar.component';
import { BaseConhecimentoDetalharComponent } from './base-conhecimento-detalhar/base-conhecimento-detalhar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    BaseConhecimentoListarComponent,
    BaseConhecimentoDetalharComponent
  ],
  imports: [
    CommonModule,
    BaseConhecimentoRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    MessagesModule,
    ProgressSpinnerModule,
    TooltipModule,
    DividerModule,
    DropdownModule
  ]
})
export class BaseConhecimentoModule { }
